import { createSlice } from "@reduxjs/toolkit";
import {
  getProfileImage,
  uploadProfileImage,
  deleteProfileImage,
} from "../actions/imgAction";

const initialState = {
  loading: false,
  error: null,
  imageData: {}, // Yüklenen resim verisi
};

const imgSlice = createSlice({
  name: "img",
  initialState,
  reducers: {
    clearImageData: (state, action) => {
      const userId = action.payload;
      if (userId && state.imageData[userId]) {
        state.imageData[userId] = { data: [] };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadProfileImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadProfileImage.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        // Upload sonrası state'i güncelle
        const userId = action.meta.arg.userId;
        if (!state.imageData[userId]) {
          state.imageData[userId] = { data: [] };
        }
        // Yeni yüklenen resmi ekle
        if (action.payload.data) {
          state.imageData[userId].data = action.payload.data;
        }
      })
      .addCase(uploadProfileImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getProfileImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfileImage.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        const { userId, data } = action.payload;
        /* console.log("🔄 Redux State Güncelleniyor - userId:", userId);
        console.log("📥 Gelen data:", data); */
        if (data) {
          state.imageData[userId] = { data };
          /* console.log("✅ Güncellenmiş state:", state.imageData[userId]); */
        }
      })
      .addCase(getProfileImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteProfileImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProfileImage.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        // Silinen resmin ID'sine sahip veriyi state'den kaldır
        if (action.payload?.success) {
          Object.keys(state.imageData).forEach((userId) => {
            if (
              state.imageData[userId]?.data?.some(
                (img) => img._id === action.payload.imageId
              )
            ) {
              state.imageData[userId] = { data: [] };
            }
          });
        }
      })
      .addCase(deleteProfileImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // 404 hatası durumunda state'i temizle
        if (action.payload?.includes("404")) {
          Object.keys(state.imageData).forEach((userId) => {
            state.imageData[userId] = { data: [] };
          });
        }
      });
  },
});

export const { clearImageData } = imgSlice.actions;
export default imgSlice.reducer;
